import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en"; // Import English locale
import { useParams } from "react-router-dom";
import ActionMenuHeader from "../../../components/admin/common/ActionMenuHeader";
import TeamMemberCommissions from "../../../components/admin/teamMemberProfile/TeamMemberCommissions";
import TeamMemberPackageList from "../../../components/admin/teamMemberProfile/TeamMemberPackageList";
import TeamMemberPermissions from "../../../components/admin/teamMemberProfile/TeamMemberPermissions";
import TeamMemberProfileCard from "../../../components/admin/teamMemberProfile/TeamMemberProfileCard";
import TeamMemberServiceList from "../../../components/admin/teamMemberProfile/TeamMemberServiceList";
import TeamMemberWorkingHours from "../../../components/admin/teamMemberProfile/TeamMemberWorkingHours";
import TeamMemberWorkingLocations from "../../../components/admin/teamMemberProfile/TeamMemberWorkingLocations";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import {
  adminShowTeamMember,
  getLocationDetailsAdmin,
} from "../../../network/admin";
type Props = {};

const TeamMemberProfile = (props: Props) => {
  let { teamName } = useParams();
  const locationId = useParams()?.salonName;
  console.log(locationId);

  const { data, isLoading } = useQuery(
    ["team-member", teamName],
    () => adminShowTeamMember(teamName),
    { enabled: !!teamName }
  );
  const { data: locationDetails } = useQuery(
    ["location", locationId],
    () => getLocationDetailsAdmin(locationId),
    {
      select: (res) => res.data,
      enabled: !!locationId,
    }
  );
  const MockData = [
    { time: { timeStart: 5, TimeEnd: 6 } },
    { time: false },
    { time: false },
    { time: { timeStart: 5, TimeEnd: 6 } },
    { time: { timeStart: 5, TimeEnd: 6 } },
    { time: { timeStart: 5, TimeEnd: 6 } },
    { time: { timeStart: 5, TimeEnd: 6 } },
  ];
  const breadcrumb = useBreadcrumb(
    [locationDetails?.name, `Members ( ${data?.data?.name} )`],
    1
  );
  if (isLoading || !data?.data) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spin size="large" />
      </div>
    );
  }
  dayjs.locale("en");

  return (
    <>
      <div className="flex items-center justify-between w-full mb-2 ml-auto">
        {breadcrumb}
        <ActionMenuHeader LocationId={1} />
      </div>
      <div className="grid h-full grid-cols-2 gap-4">
        <div className="flex flex-col w-full h-full gap-6 p-4 bg-white rounded-lg">
          <TeamMemberProfileCard data={data?.data} />
          <TeamMemberServiceList data={data?.data} />
          <TeamMemberPackageList data={data?.data} />
        </div>
        <div className="bg-[#efedff] rounded-lg h-fit w-full grid gap-4">
          <TeamMemberWorkingHours
            data={MockData}
            teamMember={data?.data}
            locationDetails={locationDetails}
          />
          <div className="grid gap-4">
            <TeamMemberWorkingLocations data={data?.data} />
            <TeamMemberPermissions data={{}} />
            <TeamMemberCommissions data={data?.data} />
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamMemberProfile;
